import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { useDrawer } from "../providers";
import styles from "../Drawer.module.scss";
const WHITE_SPACE_KEY = " ";
export const DrawerBackdrop = (props) => {
    const { isOpen, closeDrawer } = useDrawer();
    const onKeyDown = (event) => {
        if (event.key === WHITE_SPACE_KEY) {
            closeDrawer();
        }
    };
    return (_jsx("div", { className: classnames(styles.drawerBackdrop, {
            [styles.isOpen]: isOpen,
        }), "data-testid": "drawer-overlay", role: "button", tabIndex: 0, onClick: closeDrawer, onKeyDown: onKeyDown, ...props }));
};
DrawerBackdrop.displayName = "DrawerBackdrop";
//# sourceMappingURL=DrawerBackdrop.js.map